import React, { Fragment, useState, useEffect } from 'react';
// import man from '../../../assets/images/user/user.png';
import { User, Mail, Lock, LogOut } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import { EditProfile } from '../../../constant'

const UserMenu = () => {
    const [profile, setProfile] = useState('');
    // auth0 profile
    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('full_name')
        localStorage.removeItem('email')
        localStorage.removeItem('first_time_login')
        localStorage.removeItem('position')
        localStorage.removeItem('role')
        window.location.reload();
    }
    useEffect(() => {
        // setProfile(localStorage.getItem('profileURL') || man);
        setProfile((localStorage.getItem('full_name') || '...').charAt(0).toUpperCase());
    }, []);


    return (
        <Fragment>
            <button className="btn p-0 d-flex align-items-center m-4" onClick={logout} style={{ border: 'none', background: 'none' }}>
                <LogOut style={{ marginRight: 4 }} /> Log out
            </button>
        </Fragment>
    );
};


export default UserMenu;